<script setup>
import {usePortalContentAndDesignStore} from "../../../../stores/partners/portalContentAndDesignStore";
import TermsOfServices from "../../../app/programs/portal/signup/TermsOfServices.vue";

const portalContentAndDesignStore = usePortalContentAndDesignStore();

</script>

<template>
    <div class="divide-y">
        <div class="pb-6 space-y-3">
            <div class="space-y-2">
                <h3 class="text-lg font-medium">Page details</h3>
                <p class="text-gray-500 text-sm">The heading and the description of your sign-up page.</p>
            </div>
            <text-field
                label="Title"
                name="portal_signup_title"
                type="text"
                v-model="portalContentAndDesignStore.translationSettings.portal_signup_title"
            >
            </text-field>

            <text-editor
                name="portal_signup_description"
                :text="portalContentAndDesignStore.translationSettings.portal_signup_description"
                @input="(newValue) => { portalContentAndDesignStore.translationSettings.portal_signup_description = newValue }"
            >
            </text-editor>

            <radio-group-inline
                label="Branding"
                name="program_signup_page_branding_type"
                v-model="portalContentAndDesignStore.signupPageSettings.signup.program_signup_page_branding_type"
                :options="[
                            { value: 'none', label: 'None'},
                            { value: 'symbol', label: 'Symbol'},
                            { value: 'logo', label: 'Logo'}
                        ]">
                <template #note>
                    Select which image to display above the signup title.
                </template>
            </radio-group-inline>
        </div>
        <div class="py-6 space-y-3">
            <div class="space-y-2">
                <h3 class="text-lg font-medium">Terms of Use</h3>
                <p class="text-gray-500 text-sm">Add your partner program terms.</p>
            </div>
            <terms-of-services
                :tos-url="portalContentAndDesignStore.signupPageSettings.signup.portal_signup_tos_url"
                @update:tos-url="portalContentAndDesignStore.signupPageSettings.signup.portal_signup_tos_url = $event"
                :tos-save="portalContentAndDesignStore.signupPageSettings.signup.portal_signup_tos_saved_locally"
                @update:tos-save="portalContentAndDesignStore.signupPageSettings.signup.portal_signup_tos_saved_locally = $event"
                :tos-text="portalContentAndDesignStore.signupPageSettings.signup.portal_signup_tos_text"
                @update:tos-text="portalContentAndDesignStore.signupPageSettings.signup.portal_signup_tos_text = $event"
            >
            </terms-of-services>
        </div>

        <div class="py-6 space-y-3">
            <div class="space-y-2">
                <h3 class="text-lg font-medium">Marketing consent</h3>
                <p class="text-gray-500 text-sm">Collect marketing permissions from your partners.</p>
            </div>
            <text-field
                label="Text"
                name="portal_signup_marketing_consent_text"
                placeholder="E.g. I’d like to receive updates regarding my affiliate account"
                type="text"
                v-model="portalContentAndDesignStore.signupPageSettings.signup.marketing_consent"
            >
                <template #note>
                    Once text is entered, a checkbox will appear on your signup form.
                </template>
            </text-field>
        </div>
    </div>
</template>
